import React from 'react';
import { css } from '@emotion/react';

import theme from '../../theme';
import Button from "../components/Button";
import { StripePlan } from "../hooks/useStripePlans";

type Props = {
    plan: StripePlan | null,
    isSubmitting: boolean,
    onClick: () => void,
};

const PlanSelectionFooter: React.FC<Props> = ({ plan, isSubmitting, onClick }) => (
    <div css={containerStyle}>
        <div css={buttonStyle}>
            <Button
                color={"secondary"}
                disabled={!plan}
                disabledTooltipMessage={"Please select a plan"}
                forceLoading={isSubmitting}
                onClick={onClick}
                size="lg"
                type="submit"
                rounded
            >
                Continue
            </Button>
        </div>
    </div>
);

const containerStyle = css`
    width: 100%;
    margin-top: 20px;
`;

const buttonStyle = css`
    text-align: right;
    margin-top: 22px;
    height: 32px;
    display: block;

    ${theme.breakpoints.down('md')} {
        display: none;
    }
`;

export default PlanSelectionFooter;
